export default __webpack_public_path__ + "static/media/img2.a23f790d.svg";